document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.querySelector('[data-kara-quote-drawer]');
  const triggers = document.querySelectorAll('[data-kara-quote-trigger]');

  if (!drawer || !triggers.length) return;

  const closeButtons = drawer.querySelectorAll('[data-kara-quote-close]');

  /* ============================================
     OPEN DRAWER
  ============================================ */

  function openQuoteDrawer() {
    const productForm = document.querySelector(
      'form[data-type="add-to-cart-form"]'
    );

    if (productForm) {
      const variantInput = productForm.querySelector('input[name="id"]');
      const quantityInput = productForm.querySelector('input[name="quantity"]');

      if (variantInput) {
        const variantId = variantInput.value;

        fetch(window.Shopify.routes.root + 'variants/' + variantId + '.js')
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Unable to load variant');
            }

            return response.json();
          })
          .then(function (variant) {
            updateQuoteProduct(variant, quantityInput);
          })
          .catch(function (error) {
            console.error('KARA Quote:', error);
          });
      }
    }

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('kara-quote-open');

    const closeButton = drawer.querySelector(
      '.kara-quote-drawer__close'
    );

    if (closeButton) {
      closeButton.focus();
    }
  }


  /* ============================================
     CLOSE DRAWER
  ============================================ */

  function closeQuoteDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('kara-quote-open');
  }


  /* ============================================
     UPDATE PRODUCT / VARIANT DATA
  ============================================ */

  function updateQuoteProduct(variant, quantityInput) {
    const variantTarget = drawer.querySelector(
      '[data-kara-quote-variant]'
    );

    const skuTarget = drawer.querySelector(
      '[data-kara-quote-sku]'
    );

    const formVariant = drawer.querySelector(
      '[data-kara-quote-form-variant]'
    );

    const formSku = drawer.querySelector(
      '[data-kara-quote-form-sku]'
    );

    const formVariantId = drawer.querySelector(
      '[data-kara-quote-form-variant-id]'
    );

    const formQuantity = drawer.querySelector(
      '[data-kara-quote-form-quantity]'
    );


    /* Displayed variant */

    if (variantTarget) {
      if (variant.title && variant.title !== 'Default Title') {
        variantTarget.textContent = variant.title;
        variantTarget.style.display = '';
      } else {
        variantTarget.textContent = '';
        variantTarget.style.display = 'none';
      }
    }


    /* Displayed SKU */

    if (skuTarget) {
      if (variant.sku) {
        skuTarget.textContent = 'SKU: ' + variant.sku;
        skuTarget.style.display = '';
      } else {
        skuTarget.textContent = '';
        skuTarget.style.display = 'none';
      }
    }


    /* Store variant data on drawer */

    drawer.dataset.variantId = variant.id;
    drawer.dataset.variantTitle = variant.title || '';
    drawer.dataset.variantSku = variant.sku || '';


    /* Hidden form fields */

    if (formVariant) {
      formVariant.value = variant.title || '';
    }

    if (formSku) {
      formSku.value = variant.sku || '';
    }

    if (formVariantId) {
      formVariantId.value = variant.id;
    }


    /* Quantity */

    const quantity = quantityInput
      ? quantityInput.value
      : '1';

    drawer.dataset.quantity = quantity;

    if (formQuantity) {
      formQuantity.value = quantity;
    }
  }


  /* ============================================
     SUCCESS STATE
  ============================================ */

  const quoteSuccess = drawer.querySelector(
    '[data-kara-quote-success]'
  );

  if (quoteSuccess) {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('kara-quote-open');
  }


  /* ============================================
     EVENTS
  ============================================ */

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', openQuoteDrawer);
  });


  closeButtons.forEach(function (button) {
    button.addEventListener('click', closeQuoteDrawer);
  });


  /* Close when clicking overlay */

  const overlay = drawer.querySelector(
    '.kara-quote-drawer__overlay'
  );

  if (overlay) {
    overlay.addEventListener('click', closeQuoteDrawer);
  }


  /* Close with Escape */

  document.addEventListener('keydown', function (event) {
    if (
      event.key === 'Escape' &&
      drawer.classList.contains('is-open')
    ) {
      closeQuoteDrawer();
    }
  });
});